export default __webpack_public_path__ + "static/largeHex-64e09b7798ec6b2f044e7a65a30a9857.jpg";